// Coalesces concurrent calls for the same resource: the first caller runs the real request via
// `resolver`, later callers queue and are settled together when it completes. The drain is guarded
// so a request that throws synchronously, never calls back, or is slow can't leave queued callers
// hanging forever (which previously wedged the pool and every subsequent request).
const POOL_REQUEST_TIMEOUT_MS = 30_000;

export default class RequestPool {
  waiting = [];

  request(resolver, callback) {
    const waiting = this.waiting;

    waiting.push(callback);

    if (waiting.length !== 1) {
      return;
    }

    let settled = false;
    const drain = (...args) => {
      if (settled) {
        return;
      }
      settled = true;
      clearTimeout(timer);

      while (waiting.length) {
        waiting.shift()?.(...args);
      }
    };

    // Safety net: release everyone if the underlying request never settles, so a single hung
    // request cannot wedge the pool. The once-guard prevents a late real response double-calling.
    const timer = setTimeout(() => drain(new Error('Request pool timed out.')), POOL_REQUEST_TIMEOUT_MS);

    try {
      resolver(drain);
    } catch (error) {
      drain(error);
    }

    return false;
  }
}
